import { StoreState } from '../reducers';
import { createSelector } from 'reselect';
import { ISeance } from 'src/types/seance';
import { changeToZeroMoment } from '../../helpers/timeHelpers';
import _ from 'lodash';
import moment from 'moment';
import OrderEnum from '../../enumerables/order-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';

export const miniLoaderForSelector = (state: StoreState) => state.seances.miniLoaderFor;

export const copySeanceNoteSelector = (state: StoreState) => state.seances.copySeance;

export const Selector = (state: StoreState) => state.seances.unconfirmed;

export const selectGroupUnconfirmed = createSelector(Selector, (items): {
    data: {
        [key: string]: {
            list: { text: string; id: string; time: number }[];
            title: string;
            provider: string;
            occasion: string;
        };
    };
    lengthUnc: number;
} => {
    const arrSeances: {
        [key: string]: {
            list: { text: string; id: string; time: number }[];
            title: string;
            provider: string;
            occasion: string;
        };
    } = {};
    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);
    items.forEach((item: ISeance) => {
        let name = '';
        let caseNumber = '';
        if (+item.occasion.caseType === 1) {
            caseNumber = item.occasion.caseNumber ? item.occasion.caseNumber + ',' : '';
        }
        if (+item.occasion.caseType === 3) {
            name = item.district ? `${item.district.name}` : 'unknown';
        } else if (+item.occasion.caseType === 4) {
            name = item.vendor ? `${item.vendor.name}` : 'unknown';
        } else {
            name = item.student ? `${item.student.firstName} ${item.student.lastName}` : 'unknown';
        }

        let serviceType = item?.serviceType?.title;
        if (!serviceType) {
            serviceType = item?.serviceType?.cpt;
        }
        const serviceLocation = item?.serviceLocation?.title ? `, ${item.serviceLocation?.title}` : '';

        const orderTypeLabel: SelectObject | undefined | string = orderTypes.find(
            (it) => it.value === item.occasion.orderType,
        );

        const orderTypeText = orderTypeLabel ? `${orderTypeLabel.label},` : '';

        const titleCase = `${name} (${orderTypeText} ${caseNumber} ${serviceType}${serviceLocation}  )`;

        const seanceDate = changeToZeroMoment(item.seanceDate, 'YYYY-MM-DD');
        const startTime = changeToZeroMoment(item.startTime, 'LT');
        const endTime = changeToZeroMoment(item.endTime, 'LT');
        const time = moment(`${item.seanceDate}-${item.endTime}`, 'YYYY-MM-DD-H:m A').unix();
        const textDate = `${seanceDate} (${startTime} - ${endTime})`;

        if (arrSeances[`${item.occasion.id}`]) {
            arrSeances[`${item.occasion.id}`].list.push({ text: textDate, id: `${item.id}`, time });
        } else {
            arrSeances[`${item.occasion.id}`] = {
                ...arrSeances[`${item.occasion.id}`],
                title: titleCase,
                occasion: `${item.occasion.id}`,
                provider: `${item.provider.id}`,
                list: [{ text: textDate, id: `${item.id}`, time }],
            };
        }
    });

    _.forEach(arrSeances, (it: any) => {
        it.list.sort((a: { text: string; id: string; time: number }, b: { text: string; id: string; time: number }) => {
            return a.time > b.time ? -1 : a.time < b.time ? 1 : 0;
        });
    });
    return { data: arrSeances, lengthUnc: items.length };
});
